var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppleWellness(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3381_25423)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 21.5,
    r: 4.5,
    fill: "#FDB5C1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_3381_25423",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2557 11.8726C18.5184 8.75976 20.1037 5.78024 22.8557 3.8381C25.6077 1.89602 28.9461 1.40069 31.9668 2.19615C31.7042 5.30896 30.1188 8.28848 27.3668 10.2306C24.6148 12.1727 21.2765 12.668 18.2557 11.8726Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.2557 11.8726L16.8606 11.7548L16.7617 12.9269L17.8992 13.2264L18.2557 11.8726ZM31.9668 2.19615L33.3619 2.31387L33.4608 1.14182L32.3234 0.842297L31.9668 2.19615ZM19.6507 11.9903C19.8801 9.27192 21.263 6.67563 23.663 4.98194L22.0485 2.69425C18.9444 4.88485 17.1566 8.2476 16.8606 11.7548L19.6507 11.9903ZM23.663 4.98194C26.0629 3.28831 28.9723 2.85533 31.6103 3.54999L32.3234 0.842297C28.9198 -0.0539531 25.1525 0.503719 22.0485 2.69425L23.663 4.98194ZM30.5718 2.07842C30.3424 4.79679 28.9595 7.39309 26.5595 9.08677L28.174 11.3745C31.2781 9.18387 33.0659 5.82112 33.3619 2.31387L30.5718 2.07842ZM26.5595 9.08677C24.1597 10.7804 21.2502 11.2134 18.6122 10.5187L17.8992 13.2264C21.3027 14.1227 25.07 13.565 28.174 11.3745L26.5595 9.08677Z",
    fill: "#00406B",
    mask: "url(#path-2-inside-1_3381_25423)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.54364 15.0321C9.40574 13.6394 10.8367 13.2439 12.753 13.2614C13.6915 13.2699 14.6918 13.3774 15.7382 13.4898L15.7985 13.4962C16.8516 13.6093 17.9502 13.7255 19 13.7255C20.0498 13.7255 21.1484 13.6093 22.2015 13.4962L22.2618 13.4898C23.3082 13.3774 24.3085 13.2699 25.247 13.2614C27.1633 13.2439 28.5943 13.6394 29.4564 15.0321C30.6234 16.9173 31.3 19.1655 31.3 21.6213C31.3 28.6426 25.7743 34.3 19 34.3C12.2257 34.3 6.7 28.6426 6.7 21.6213C6.7 19.1655 7.37664 16.9173 8.54364 15.0321Z",
    stroke: "#00406B",
    strokeWidth: 1.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3381_25423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleWellness);
export default __webpack_public_path__ + "static/media/apple-wellness.0a04fea36690917cb0f8051af7a3b513.svg";
export { ForwardRef as ReactComponent };